import { render, staticRenderFns } from "./LoveToggle.vue?vue&type=template&id=0b382d2e"
import script from "./LoveToggle.vue?vue&type=script&lang=js"
export * from "./LoveToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports